var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',[_c('div',{staticClass:"flex items-center justify-between"},[_c('div',{staticClass:"flex items-center gap-3 sm:gap-4"},[_c('div',{class:[
          'text-2xl sm:text-3xl p-2 sm:p-3 rounded-xl',
          _vm.type === 'total'
            ? 'bg-[#FF5722] bg-opacity-10 text-[#FF5722]'
            : _vm.type === 'active'
            ? 'bg-green-100 text-green-600'
            : 'bg-red-100 text-red-600'
        ]},[_vm._t("icon")],2),_c('div',[_c('h3',{staticClass:"text-base sm:text-lg font-semibold text-[#4A4453]"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"text-2xl sm:text-3xl font-bold mt-1 sm:mt-2",class:[
            _vm.type === 'total'
              ? 'text-[#FF5722]'
              : _vm.type === 'active'
              ? 'text-green-600'
              : 'text-red-600'
          ]},[_vm._v(" "+_vm._s(_vm.value)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }